// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/component/element/Diff.css
// module id = 1995
// module chunks = 0